module.exports = __webpack_public_path__ + "img/logo-white.e66f5dc8.png";